import { InputAdornment, TextFieldProps, useTheme } from '@mui/material';
import JTextFieldBase from '@atoms/JTextFieldBase';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { IconSize } from '@constants';

interface Props extends Omit<TextFieldProps, 'onChange'> {
  label?: string;
  value?: string;
  defaultValue?: string;
  onChange: (value: string) => void;
  fullWidth?: boolean;
  whiteBg?: boolean;
}

export const SearchTextField = ({
  onChange,
  label,
  value,
  defaultValue,
  fullWidth = false,
  whiteBg = false,
}: Props) => {
  const theme = useTheme();
  return (
    <JTextFieldBase
      defaultValue={defaultValue}
      value={value}
      fullWidth={fullWidth}
      onChange={(ev) => onChange(ev.target.value)}
      label={label}
      attr={{ whiteBg }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <MagnifyingGlassIcon
              color={theme.palette.primary.main}
              width={IconSize.sm}
            />
          </InputAdornment>
        ),
      }}
      size="small"
    />
  );
};
